import { defineComponent as _defineComponent } from 'vue'

  import { EstateMapInterface } from "@/types/EstateMapInterface";
  import { StageMapInterface } from "@/types/StageInterface";
  import { getStageStatusClass } from "@/helpers/status";
  import { StageStatus } from "@/enums/StageStatus";
  import { UserRoles } from "@/enums/UserRoles";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EstateSvgMap',
  props: {
    map: {},
    stages: {},
    zoom: {},
    getTooltipText: { type: Function },
    getItemPathClasses: { type: Function }
  },
  emits: ["onStageHover", "onStageLeave", "onStageClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emits = __emit;

  const onStageHover = (id: string) => {
    emits("onStageHover", id);
  };

  const onStageLeave = () => {
    emits("onStageLeave");
  };

  const onStage = (stage: StageMapInterface) => {
    emits("onStageClick", stage);
  };

const __returned__ = { props, emits, onStageHover, onStageLeave, onStage, get EstateMapInterface() { return EstateMapInterface }, get StageMapInterface() { return StageMapInterface }, get getStageStatusClass() { return getStageStatusClass }, get StageStatus() { return StageStatus }, get UserRoles() { return UserRoles } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})